
import api from '/plugins/api';
import xml2json from '/plugins/xml2json';
import { DateTime } from 'luxon';


import { v4 as uuid } from 'uuid';

let refresh_timer = null;

const formatUnidade = unidade => {
    unidade.codigo = +unidade.codigo;
    unidade.adimplente = unidade.adimplente == 'S';
    unidade.inadimplente = !unidade.adimplente;
    return unidade;
};

const formatCondominio = condominio => {
    condominio.codigo = +condominio.codigo;

    if (condominio.unidades && 0 !== Object.keys(condominio.unidades)) {
        if (condominio.unidades.unidade && 0 !== Object.keys(condominio.unidades.unidade)) {
            let unidades = condominio.unidades.unidade;
            if (!(unidades instanceof Array)) {
                unidades = [unidades];
            }
            condominio.unidades = unidades.map(formatUnidade);
        }
    }

    return condominio;
};

const formatContrato = contrato => {
    contrato.uid = uuid();
    if (contrato.imovel && 0 !== Object.keys(contrato.imovel)) {
        contrato.imovel = formatImovel(contrato.imovel);

    }
    return contrato;
};

const formatFilial = filial => {
    filial.codigo = +filial.codigo;
    filial.empresa = +filial.empresa;
    return filial;
};

const formatImovel = imovel => {
    imovel.codigo = +imovel.codigo;
    imovel.subcodigo = +imovel.subcodigo;
    imovel.filial = formatFilial(imovel.filial);
    
    return imovel;
};

const formatRelacao = relacao => {
    relacao.descricao = relacao.descricaoRelacao || '';
    relacao.uid = uuid();
    if (relacao.condominios && 0 !== Object.keys(relacao.condominios)) {
        if (relacao.condominios.condominio && 0 !== Object.keys(relacao.condominios.condominio)) {
            let condominios = relacao.condominios.condominio;
            if (!(condominios instanceof Array)) {
                condominios = [condominios];
            }
            relacao.condominios = condominios.map(condominio => formatCondominio(condominio));

        }
    }

    if (relacao.contratos && 0 !== Object.keys(relacao.contratos)) {
        if (relacao.contratos.contrato && 0 != Object.keys(relacao.contratos.contrato)) {
            let contratos = relacao.contratos.contrato;
            if (!(contratos instanceof Array)) {
                contratos = [contratos];
            }
            relacao.contratos = contratos.map(contrato => formatContrato(contrato));
        }
    }

    if (relacao.imoveis && 0 !== Object.keys(relacao.imoveis)) {
        
        if (relacao.imoveis.imovel && 0 != Object.keys(relacao.imoveis.imovel)) {
            let imoveis = relacao.imoveis.imovel;
            if (!(imoveis instanceof Array)) {
                imoveis = [imoveis];
            }
            relacao.imoveis = imoveis.map(imovel => formatImovel(imovel));
        }
    }

    
    return relacao;
};

let timer_date_time = null;

export default {
    updateDateTime({ commit, dispatch }) {
        commit('setAgora', DateTime.local().toFormat('yyyy-LL-dd HH:mm:ss'));
        if (timer_date_time) {
            window.clearTimeout(timer_date_time);
        }
        timer_date_time = window.setTimeout(() => {
            dispatch('updateDateTime');
        }, 1000);
    },
    showDrawer({ commit }) {
        commit('setDrawer', true);
    },
    hideDrawer({ commit }) {
        commit('setDrawer', false);
    },
    toggleDrawer({ state, dispatch }) {
        if (state.drawer) {
            return dispatch('hideDrawer');
        }
        return dispatch('showDrawer');
    },
    setCliente({ commit }, cliente) {
        
        commit('setCliente', cliente);
    },
    async setRelacoes({ commit, state, dispatch }, relacoes) {
        let vinculos = [...new Set(relacoes.map(({ sistema }) => sistema ))];
        
        if (vinculos.length != 0 && !vinculos.includes(state.vinculo_id)) {
            let [vinculo_id] = vinculos;
            await dispatch('setVinculoId', vinculo_id);
        }
        commit('setRelacoes', relacoes);
        
        
        if ('undefined' == typeof relacoes[state.relacao_id]) {
            await dispatch('setRelacaoId', 0);
        }
    },
    setVinculoId({ commit, dispatch, state }, vinculo_id) {
        if (state.vinculo_id != vinculo_id) {
            commit('setVinculoId', vinculo_id);
            dispatch('setRelacaoId', 0);

        }

        //dispatch('setRelacaoId', 0);
    },
    setRelacaoId({ commit }, relacao_id) {
        commit('setContratoId', 0);
        commit('setImovelId', 0);
        commit('setCondominioId', 0);
        commit('setRelacaoId', relacao_id);
    },
    setCondominioId({ commit }, condominio_id) {
        commit('setContratoId', 0);
        commit('setImovelId', 0);
        //commit('setCondominioId', 0);

        commit('setCondominioId', condominio_id);
    },
    setContratoId({ commit }, contrato_id) {
        //commit('setContratoId', 0);
        
        commit('setImovelId', 0);
        commit('setCondominioId', 0);
        commit('setContratoId', contrato_id);
    },
    setImovelId({ commit }, imovel_id) {
        
        commit('setContratoId', 0);
        //commit('setImovelId', 0);
        commit('setCondominioId', 0);
        commit('setImovelId', imovel_id);
    },
    setRefreshToken({ commit }, refresh_token) {
        commit('setRefreshToken', refresh_token);
        if (null === refresh_token) {
            commit('setJwt', null);
        }
    },
    setJwt({ commit }, jwt) {
        commit('setJwt', jwt);
        if (null === jwt) {
            commit('setExpiresAt', null);
        }
    },
    setExpiresAt({ commit, dispatch }, expiresAt) {
        commit('setExpiresAt', expiresAt);
        
        if (refresh_timer) {
            window.clearTimeout(refresh_timer);
        }
        refresh_timer = window.setTimeout(() => {
            dispatch('refresh');
        //}, 10000);
        }, 29*60000);
    },
    async refresh({ state: { refresh_token }, dispatch}) {
        try {
            if (!refresh_token) {
                return;
            }

            

            let { data: { jwt, expiresAt, refresh_token: token} } = await api.post('auth/refresh', { refresh_token });
            await Promise.all([
                dispatch('setJwt', jwt),
                dispatch('setExpiresAt', expiresAt),
                dispatch('setRefreshToken', token),
            ]);
            await dispatch('loadDadosCliente')
        } catch (err) {
            console.error(err, 'refresh error');
            dispatch('setCliente', {}),
            dispatch('setRelacoes', []),
            dispatch('setRelacaoId', 0),
            dispatch('setCondominioId', 0),
            dispatch('setContratoId', 0),
            dispatch('setImovelId', 0),
            dispatch('setRefreshToken', null),
            dispatch('setJwt', null)
            
            //await router.replace('/login');
            location.reload(true)
        }
    },
    async loadDadosCliente({ dispatch, state }) {
        try {
            let { data: xml } = await api.get('auth/dados-cliente');
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xml, 'text/xml');
            let { relacaoCliente } = xml2json(xmlDoc);
            if (!relacaoCliente) {
                throw new Error("Não foi possível completar a solicitação.");
            }
            if (relacaoCliente.erros && relacaoCliente.erros.erro) {
                throw new Error(relacaoCliente.erros.erro);
            }
            if (relacaoCliente.erros) {
                throw new Error("Não foi possível completar a solicitação.");
            }
            let { cliente, relacoes } = relacaoCliente;
            
            cliente.codigo = +cliente.codigo;

            if (relacoes && 0 != Object.keys(relacoes)) {
                if (relacoes.relacao && 0 != Object.keys(relacoes.relacao)) {
                    relacoes = relacoes.relacao;
                    if (!(relacoes instanceof Array)) {
                        relacoes = [relacoes]
                    }
                    relacoes = relacoes.map(formatRelacao);
                }
            }

            
            await Promise.all([
                dispatch('setCliente', cliente),
                dispatch('setRelacoes', relacoes)
            ]);
            

        } catch (err) {
            console.error(err);
        }
    }
};
